import { Component, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { LatLngLiteral } from '@agm/core';
import { BaseWidget } from 'src/app/tools/abstract-classes/base-widget';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { Branch } from 'src/app/assabil-kernel/models/entities/control-tables/branch-entity';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { marker } from 'src/app/tools/models/entities/marker';



@Component({
  selector: 'branch-widget',
  templateUrl: './branch-widget.component.html',
  styleUrls: ['./branch-widget.component.scss']
})

export class BranchWidgetComponent extends BaseWidget {

  branch: Branch = new Branch();

  
  constructor(
    protected controlTablesService: ControlTablesService,
    protected toastr              : ToastrService,
    protected leanUtilsService    : LeanUtilsService,
    protected router              : Router) {
      super(toastr, leanUtilsService);

      this.entityName = "branch";
  }

//---------------------------------------------------------------------------------------
    setEntity(branch: Branch) {
      this.branch = { ...branch };
      this.buildPoints();
    }
//---------------------------------------------------------------------------------------


//---------------------------------------------------------------------------------------
getEntity(){
  return this.branch;
}
//---------------------------------------------------------------------------------------


//---------------------------------------------------------------------------------------
saveRow() : Promise<Branch>{
    return this.controlTablesService.branchSave(this.branch);
}
//---------------------------------------------------------------------------------------


//---------------------------------------------------------------------------------------
  onMapClick(point : LatLngLiteral){
    if (this.branch.edit){
      this.branch.latitude = point.lat;
      this.branch.longitude = point.lng;
    }
  }

  points : marker[] = [];
  buildPoints(){
      let point : marker = {     
        lat: this.branch.latitude,
        lng: this.branch.longitude,
        label: this.branch.name,
        draggable: false,
        iconUrl: 'http://maps.google.com/mapfiles/ms/icons/green.png'
      };
    
      this.points.push(point);
    }
//---------------------------------------------------------------------------------------

}
